import type { Product } from '@/types/product';
import type { RegistryProduct } from '@/types/productRegistry';

const defaultRegistryFields: Pick<
  RegistryProduct,
  'category' | 'status' | 'environment' | 'renderMode' | 'activeUsers' | 'lastModified'
> = {
  category: 'monitoring',
  status: 'active',
  environment: 'production',
  renderMode: 'iframe',
  activeUsers: 0,
  lastModified: new Date().toISOString(),
};

export function mapProductToRegistry(product: Product): RegistryProduct {
  return {
    id: product.id,
    name: product.name,
    description: product.description ?? undefined,
    category: 'monitoring',
    status: product.isActive === false ? 'inactive' : 'active',
    environment: 'production',
    icon: product.icon ?? undefined,
    renderMode: 'iframe',
    iframeUrl: product.iframeUrl,
    activeUsers: 0,
    lastModified: new Date().toISOString(),
    version: undefined,
    owner: undefined,
  };
}

export function mergeRegistryProduct(
  base: RegistryProduct,
  overrides: Partial<RegistryProduct>,
): RegistryProduct {
  return {
    ...defaultRegistryFields,
    ...base,
    ...overrides,
  };
}
